// context/SocketContext.js

import { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        // Initialize Socket.IO client
        const socketIo = io({
            path: '/api/socket',
            transports: ['websocket'],
            reconnectionAttempts: 5, // Number of reconnection attempts before giving up
            reconnectionDelay: 1000, // Initial delay before reconnection attempt
            reconnectionDelayMax: 5000, // Maximum delay between reconnection attempts
            timeout: 20000, // Connection timeout
        });

        // Set socket instance
        setSocket(socketIo);

        // Connection established
        socketIo.on('connect', () => {
            console.log('Socket connected:', socketIo.id);
            setIsConnected(true);
        });

        // Handle reconnection attempts
        socketIo.on('reconnect_attempt', (attempt) => {
            console.log(`Reconnection attempt #${attempt}`);
        });

        // Handle successful reconnection
        socketIo.on('reconnect', (attempt) => {
            console.log(`Reconnected on attempt #${attempt}`);
            setIsConnected(true);
        });

        // Handle disconnection
        socketIo.on('disconnect', (reason) => {
            console.log('Socket disconnected:', reason);
            setIsConnected(false);
        });

        // Handle connection errors
        socketIo.on('connect_error', (error) => {
            console.error('Connection error:', error);
        });

        // Cleanup on unmount
        return () => {
            socketIo.disconnect();
            console.log('Socket disconnected on cleanup');
        };
    }, []);

    return (
        <SocketContext.Provider value={{ socket, isConnected }}>
            {children}
        </SocketContext.Provider>
    );
};
